import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '#app/components/accordion.tsx'
import { Title } from './utils.tsx'
let faqs = [
	{
		title: 'Can I also earn money by referring people?',
		content: (
			<span>
				Yes! You can earn 10% of every purchase made by your referrals by
				becoming an affiliate.{' '}
				<a
					className="underline"
					href="https://luisiacc.lemonsqueezy.com/affiliates"
					target="_blank"
					rel="noreferrer"
				>
					Become an affiliate here
				</a>
				.
			</span>
		),
	},
	{
		title: 'Are there any costs involved?',
		content:
			'You can check out or plans when you sign up, we have $9, $15 and $25 plans.',
	},
	{
		title: 'Can I re-use the faces I have used in the past',
		content: 'Yes, you can store as many faces as you want to use later.',
	},
	{
		title: 'How long can I store my faces?',
		content:
			'Forever! You can store as many as you want for as long as you want.',
	},
	{
		title: 'How do I get the best results?',
		content:
			'For the best result, use a clear, well-lit face photo. Your face must be clearly visible and at least ' +
			'480p quality, otherwise the results may dissappoint you.',
	},
	{
		title: 'Can I use the app on my phone?',
		content:
			'Yes! Our app is designed to work smoothly on both desktop and mobile devices.',
	},
	{
		title: "I'm an artist. Can I use this for my projects?",
		content:
			'Certainly! Artists and designers love our app for its creative possibilities. You are free to use the ' +
			'images you create for any purpose, including commercial projects.',
	},
	{
		title: 'Can I upload photos of kids or minors?',
		content:
			'No. We do not allow photos of kids or minors. If you upload such photos, your will assume full ' +
			'responsibility for any legal issues that may arise.',
	},
	{
		title: 'Is the payment secure?',
		content:
			'Yes, we use Stripe to process payments. Stripe is a leading payment processor trusted by millions of ' +
			'businesses worldwide.',
	},
	{
		title: 'Can I request a feature or give feedback?',
		content:
			'Absolutely! We value your feedback and always look to improve. Let us know your thoughts or suggestions ' +
			'through our email.',
	},
]

export function FAQS() {
	return (
		<section className="w-full bg-[var(--darker-bg)]" id="faqs">
			<div className="container pb-20 pt-20">
				<Title>FAQs</Title>
				<div className="h-20" />
				<div className="flex flex-col gap-8">
					{faqs.map(faq => (
						<Faq key={faq.title} title={faq.title} content={faq.content} />
					))}
				</div>
			</div>
		</section>
	)
}

function Faq({
	title,
	content,
}: {
	title: string
	content?: string | JSX.Element
}) {
	return (
		<Accordion type="single" collapsible>
			<AccordionItem value="item-1">
				<AccordionTrigger className="text-h5" iconClassName="w-10 h-10">
					{title}
				</AccordionTrigger>
				<AccordionContent className="text-lg">{content}</AccordionContent>
			</AccordionItem>
		</Accordion>
	)
}
